module.exports = __webpack_public_path__ + "media/images/childcare/card-desktop@2x-bb63496bc0a3598b469411e4b720ed55.jpg";